/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Detail_BalancedInputs */

const en_landing_studio_detail_balanced = /** @type {(inputs: Landing_Studio_Detail_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balanced`)
};

const zh_landing_studio_detail_balanced = /** @type {(inputs: Landing_Studio_Detail_BalancedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准`)
};

/**
* | output |
* | --- |
* | "Balanced" |
*
* @param {Landing_Studio_Detail_BalancedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_detail_balanced = /** @type {((inputs?: Landing_Studio_Detail_BalancedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Detail_BalancedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_detail_balanced(inputs)
	return zh_landing_studio_detail_balanced(inputs)
});
export { landing_studio_detail_balanced as "landing.studio.detail_balanced" }